var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isValid && !_vm.loading
    ? _c("span", {
        staticClass: "amount",
        domProps: { textContent: _vm._s(_vm.formattedAmount) },
      })
    : _c("span", { staticStyle: { "user-select": "none" } }, [_vm._v("‥")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }